<template>
    <span>
        <a-button size="small" type="primary" icon="check" v-on:click.prevent="showModal">Solicitar Recuperación</a-button>
        <a-modal title="Solicitar Recuperación"
                 :visible="modalVisible"
                 @ok="confirmar"
                 :confirmLoading="modalLoading"
                 @cancel="cancelar"
                 style="top: 20px;"
                 width="70%"
        >
              <a-form :form="form" @submit="confirmar">
                <a-form-item label="Tipo Solicitud" v-bind="fiOptions">
                  {{permisos}}
                  </a-form-item>
                 <a-form-item label="Tipo permiso" v-bind="fiOptions">
                  {{recuperacion}}
                  </a-form-item>

                  <g-dropdown endpoint="permission_req"
                              label="Permisos disponibles"
                              :formItemConfig="fiOptions"
                              :cache="false"
                              :decorator="['att_4', { rules: [{ required: true, message: 'Valor requerido' }] }]">
                  </g-dropdown>

                  <a-form-item label="Fecha De Solicitud" v-bind="fiOptions">
                      <a-date-picker style="width: 100%"
                                     v-decorator="['date_permission', { rules: [{ required: true, message: 'Valor requerido' }] }]"
                                     :disabled="modalLoading"></a-date-picker>
                  </a-form-item>

                  <a-form-item label="Observación" v-bind="fiOptions">
                          <a-textarea placeholder="Observación"
                                      autoSize
                                      v-decorator="['observation']"
                                      style="text-transform: uppercase">
                          </a-textarea>
                  </a-form-item>
                  <a-alert type="error" :message="mensajeError" v-if="error"/>
              </a-form>
        </a-modal>
    </span>
</template>
<script>
  import HttpUtil from '@/util/HttpUtil'
  import DateUtils from '@/util/DateUtils'
  import Mensajes from 'CustomModules/GlobalBPOCore/Util/Mensajes'

  export default {
    data () {
      return {
        modalVisible: false,
        modalLoading: true,
        fecha_regreso: '',
        mensajeError: '',
        tipo_permiso_seleccionado: {equivalency: -1},
        tipo_solicitud_seleccionado: undefined,
        cantidadSubTipos: 0,
        error: false,
        form: this.$form.createForm(this, {
          name: 'solicitar'
        }),
        fiOptions: {
          'label-col': {span: 4},
          'wrapper-col': {span: 20},
          'has-feedback': true
        },
        fchkOptions: {
          'label-col': {span: 10},
          'wrapper-col': {offset: 10, span: 14},
          'has-feedback': true
        },
        sub_tipo: {h_lookup_type: 'SUBTIPO_SOLICITUD_PERMISO', id_h_lookup_father: -1},
        requestData: {}
      }
    },
    beforeMount () {
      this.httpClient = new HttpUtil()
      this.getPermission()
    },
    methods: {
      cancelar () {
        if (this.modalLoading) return
        this.modalVisible = false
        this.modalLoading = false
      },
      confirmar (e) {
        e && e.preventDefault()
        this.form.validateFields((err, values) => {
          if (!err) {
            console.log('entro..')
            this.modalLoading = true
            let request = {...values}
            request.date_permission = values.date_permission ? DateUtils.forBackEnd(values.date_permission) : ''
            request.recuperacion = true
            this.httpClient.getInstance().post('permission_req', request)
              .then((response) => {
                if (parseInt(response.data.resultado) === 0) {
                  this.error = true
                  this.mensajeError = response.data.mensaje
                } else {
                  this.error = false
                  this.mensajeError = ''
                  this.modalVisible = false
                  Mensajes.success('Correcto', response.data.mensaje)
                  this.form.resetFields()
                  this.$emit('success', {})
                }
              })
              .catch((error) => {
                let errorMessage = this.$getErrorMessage(error, 'No fue posible realizar la solicitud.')
                Mensajes.error('Error', errorMessage)
                this.error = true
                this.mensajeError = errorMessage
              })
              .then(() => {
                this.modalLoading = false
              })
          }
        })
      },
      showModal () {
        this.modalVisible = true
        this.modalLoading = false
        this.error = false
        this.mensajeError = ''
        this.form.resetFields()
      },
      getPermission () {
        this.httpClient.getInstance().get('permission_req_recuperacion').then(response => {
          this.requestData = response.data
          if (this.requestData.hasOwnProperty('recuperacion')) {
            if (this.requestData.permiso.hasOwnProperty('description')) {
              this.sub_tipo.id_h_lookup_father = this.requestData.recuperacion.id_h_lookup
            }
          }
        }).catch(error => {
          Mensajes.error('Error', this.$getErrorMessage(error, 'No fue posible consultar la información, contacte al administrador.'))
        })
      }
    },
    computed: {
      permisos () {
        if (this.requestData.hasOwnProperty('permiso')) {
          if (this.requestData.permiso.hasOwnProperty('description')) {
            return this.requestData.permiso.description
          }
        }
      },
      recuperacion () {
        if (this.requestData.hasOwnProperty('recuperacion')) {
          if (this.requestData.permiso.hasOwnProperty('description')) {
            return this.requestData.recuperacion.description
          }
        }
      }
    },
    watch: {
      requestData () {
        if (this.requestData.hasOwnProperty('recuperacion')) {
          if (this.requestData.permiso.hasOwnProperty('description')) {
            this.sub_tipo.id_h_lookup_father = this.requestData.recuperacion.id_h_lookup
          }
        }
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/customization/SelfService/pages/Dashboard/BotonSolicitarRecuperacion.vue